import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import cpgSquare from './../../assets/images/cpg-shapes-square.svg';
import cpgTriangle from './../../assets/images/cpg-shapes-triangle.svg';
import circleChart from './../../assets/images/cpg-circle-chart.svg';
import '../cpg.scss';
import Vivus from "vivus";
import { gsap } from 'gsap';
import AOS from "aos";
import "aos/dist/aos.css";

export default function CPGPlanning() {

  const square1Ref = useRef();
  const square2Ref = useRef();
  const triangle1Ref = useRef();
  const triangle2Ref = useRef();

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {

    document.addEventListener('aos:in:circle-chart', function(ev) {
      new Vivus('circleAnimation', {
        duration: 200,
        onReady: function (obj) {
          obj.el.style.opacity = 1;
        }
      });
    });

    document.addEventListener('aos:in:bar-anim', function(ev) {
      //console.log('animated in', ev);

      if (ev.detail.querySelectorAll('.progress').length > 1) {
        //console.log("more than 1 progress");
        var barArray = [...ev.detail.querySelectorAll('.progress')];
      } else {
        //console.log("less than 1 progress");
        var barArray = [];
        var bar = ev.detail.querySelector('.progress');
        //console.log(bar);
        barArray.push(bar);
      }

      //console.log(barArray);

      if (barArray && barArray.length) {
        barArray.forEach(function(barItem) {
          var fill = barItem.getAttribute('data-fill');

          if (!ev.detail.classList.contains('vertical-bar-chart')) {
            barItem.style.width = fill + '%';
          }
        });
      }

      var Cont={val:0};

      if (ev.detail.querySelectorAll('.percentage').length > 1) {
        var percentageArray = [...ev.detail.querySelectorAll('.percentage')];
        //console.log("more than 1 percentage");
      } else {
        var percentageArray = [];
        var percentage = ev.detail.children[0].querySelector('.percentage');
        percentageArray.push(percentage);
        //console.log("less than percentage");

      }

      //console.log(percentage);

      if (percentageArray) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }

      //console.log(percentageArray);

    });

    document.addEventListener('aos:in:percentage', function(ev) {
      var Cont={val:0};
      var percentage = ev.detail.children[0].querySelector('.percentage');
      var percentageArray = [];
      percentageArray.push(percentage);
      //console.log(percentage);

      if (percentage) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }
    });

    // Had to make some adjustments since it seemed like the animation wasn't playing nice with React. The shapes weren't incrementing exactly 90 degrees (it was adding a few degrees with decimal places) so they always rotated crooked. Possibly React strict mode causing issues. Added gsap.context, refs, and using GSAP's ScrollTrigger instead of AOS. 
    let ctx = gsap.context(() => {

      var tl = gsap.timeline({ 
        onComplete:rotateAgain,
        scrollTrigger: {
          trigger: ".shape-images"
        }
      });

      function animate(){
        tl
        .to(triangle1Ref.current, 0.5, {rotation:"+=90"})
        .to(square1Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(triangle2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(square2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
      }

      function rotateAgain(){
        gsap.delayedCall(5, animate)
      }

      animate();

    });

    return () => ctx.revert(); // <- cleanup!

    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <div id="top" className="cpg-planning">

        <p id="s1" className="intro" data-aos="fade-up">Explore the data to see how consumer packaged goods (CPG) companies integrate direct mail into omnichannel campaigns.&#8288;<a href="#reference-1" className="cm-article-content__reference" aria-label="Footnote 1" title="Footnote 1"><sup aria-hidden="true">[1]</sup></a></p>
        <div className='two-cols'>
          <div className='col-right w-50'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Mail’s Role in Omnichannel Campaigns</h3>
                <div className='circle-chart' data-aos data-aos-id="circle-chart">
                  <svg id="circleAnimation" width="547" height="547" viewBox="0 0 547 547" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path data-ignore="true" d="M524 273.5C524 306.396 517.521 338.97 504.932 369.362C492.343 399.754 473.891 427.369 450.63 450.63C427.369 473.891 399.754 492.343 369.362 504.932C338.97 517.521 306.396 524 273.5 524C240.604 524 208.03 517.521 177.638 504.932C147.246 492.343 119.631 473.891 96.3697 450.63C73.1087 427.369 54.657 399.754 42.0682 369.362C29.4794 338.97 23 306.396 23 273.5C23 240.604 29.4794 208.03 42.0682 177.638C54.657 147.246 73.1087 119.631 96.3698 96.3697C119.631 73.1087 147.246 54.657 177.638 42.0682C208.03 29.4794 240.604 23 273.5 23C306.396 23 338.97 29.4794 369.362 42.0682C399.754 54.657 427.369 73.1087 450.63 96.3698C473.891 119.631 492.343 147.246 504.932 177.638C517.521 208.03 524 240.604 524 273.5L524 273.5Z" stroke="#F2F2F2" stroke-width="46"/>
                    <path data-ignore="true" d="M454.643 273.503C454.643 297.291 449.957 320.846 440.854 342.824C431.751 364.801 418.408 384.77 401.587 401.591C384.766 418.411 364.797 431.754 342.82 440.858C320.842 449.961 297.287 454.646 273.499 454.646C249.711 454.646 226.156 449.961 204.178 440.858C182.201 431.754 162.232 418.411 145.411 401.591C128.59 384.77 115.248 364.801 106.144 342.824C97.0409 320.846 92.3555 297.291 92.3555 273.503C92.3555 249.715 97.0409 226.16 106.144 204.182C115.248 182.205 128.59 162.236 145.411 145.415C162.232 128.594 182.201 115.251 204.178 106.148C226.156 97.0448 249.711 92.3594 273.499 92.3594C297.287 92.3594 320.842 97.0448 342.82 106.148C364.797 115.251 384.766 128.594 401.587 145.415C418.408 162.236 431.751 182.205 440.854 204.182C449.957 226.16 454.643 249.715 454.643 273.503L454.643 273.503Z" stroke="#F2F2F2" stroke-width="46"/>
                    <path data-ignore="true" d="M383.98 273.502C383.98 288.01 381.123 302.376 375.571 315.78C370.019 329.184 361.881 341.363 351.622 351.622C341.363 361.881 329.184 370.019 315.78 375.571C302.376 381.123 288.01 383.98 273.502 383.98C258.994 383.98 244.627 381.123 231.224 375.571C217.82 370.019 205.641 361.881 195.382 351.622C185.123 341.363 176.985 329.184 171.433 315.78C165.881 302.376 163.023 288.01 163.023 273.502C163.023 258.994 165.881 244.627 171.433 231.224C176.985 217.82 185.123 205.641 195.382 195.382C205.641 185.123 217.82 176.985 231.224 171.433C244.628 165.881 258.994 163.023 273.502 163.023C288.01 163.023 302.376 165.881 315.78 171.433C329.184 176.985 341.363 185.123 351.622 195.382C361.881 205.641 370.019 217.82 375.571 231.224C381.123 244.628 383.98 258.994 383.98 273.502L383.98 273.502Z" stroke="#F2F2F2" stroke-width="46"/>

                    <path id="line1" d="M309.32,25.45c60,8.67,114.82,38.8,154.29,84.8,39.48,46.01,60.93,104.77,60.38,165.39-.55,60.62-23.06,118.98-63.36,164.27-40.3,45.29-95.66,74.42-155.8,82" stroke="#333366" stroke-width="46" stroke-miterlimit="16" stroke-linecap="round"/>
                    <path id="line2" d="M303.393 94.843C334.855 100.107 364.37 113.587 388.951 133.919C413.533 154.25 432.309 180.713 443.381 210.63C454.453 240.547 457.429 272.857 452.007 304.293C446.584 335.729 432.957 365.175 412.502 389.654" stroke="#D5D5EC" stroke-width="46" stroke-miterlimit="16" stroke-linecap="round"/>
                    <path id="line3" d="M303.7,167.2c16,4.6,30.8,12.7,43.3,23.8c12.5,11.1,22.2,24.9,28.6,40.3" stroke="#D5D5EC" stroke-width="46" stroke-miterlimit="16" stroke-linecap="round"/>

                    </svg>
                </div>

                <span data-aos data-aos-id="percentage" data-aos-anchor=".pie-chart">
                  <span data-aos className='percentage-value'><span class="percentage" data-to="47" aria-hidden="true">0</span><span class="screen-reader-text">47</span>%</span>
                </span>

                <p>Centerpiece</p>
                <p className="no-margin-bottom"><strong>33%</strong> — Standalone</p>
                <p><strong>20%</strong> — Supporting</p>
                <p>Direct mail serves as the centerpiece in almost half of direct mail users’ omnichannel campaigns.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>Omnichannel marketing is the ideal marketing strategy for today’s customers, who are constantly on the move and frequently moving between different devices. Direct mail can be a powerful component in omnichannel campaigns, creating a uniquely tactile, personal experience in contrast to the daily inundation of digital ads.</p>
              </div>
            </div> 

            
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3 id="s2">QR Code<sup>&reg;</sup><a href="#reference-2" class="cm-article-content__reference" aria-label="Footnote 2" title="Footnote 2"><sup aria-hidden="true">[2]</sup></a> Use</h3>
                <div data-aos data-aos-id="percentage">
                  <span data-aos className='percentage-value large highlighter '><span class="percentage" data-to="54" aria-hidden="true">0</span><span class="screen-reader-text">54</span>%</span>
                </div>
                <p>QR Code</p>
                <p>Companies in the consumer packaged goods industry use QR Codes more than businesses in any other industry.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>Including QR Codes on mailpieces is a simple way to <strong><a href="/../omnichannel-strategies/">connect physical and digital marketing.</a></strong> These barcodes can be easily scanned using a smartphone, allowing customers to be led seamlessly to your e-comm store, social selling platform, exclusive video content, or anything else you want customers to engage with.</p>
              </div>
            </div> 


          </div>

          <div className='col-left w-50'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Informed Delivery<sup>&reg;</sup> Use</h3>
                <div className='progress-bar' data-aos data-aos-id="bar-anim">
                  <div className='progress' data-fill="51"><span class="percentage" data-to="51" aria-hidden="true">0</span><span class="screen-reader-text">51</span>%</div>
                </div>
                <p>Informed Delivery</p>
                <p>CPG companies use the Informed Delivery feature more than businesses in any other industry.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>The <strong><a href="/../informed-delivery-case-studies/">Informed Delivery feature</a></strong> gives customers multiple opportunities to engage. By allowing USPS customers to receive a daily digital preview of incoming mail (via email or an online dashboard), you can better build anticipation for exciting offers and news coming their way. You can also include a complementary link, leading to a sale highlighted in your mailpiece or anything else related to the mailpiece.</p>
              </div>
            </div>

            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Informed Visibility<sup>&reg;</sup> Use</h3>
                <div className='progress-bar' data-aos data-aos-id="bar-anim">
                  <div className='progress' data-fill="66"><span class="percentage" data-to="66" aria-hidden="true">0</span><span class="screen-reader-text">66</span>%</div>
                </div>
                <p>Informed Visibility</p>
                <p>Out of all the businesses surveyed, those in the CPG sector reported using the Informed Visibility feature the most.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p> The <strong><a href="/../track-your-direct-mail-with-informed-visibility/">Informed Visibility feature</a></strong> lets marketers know when mail has been delivered, allowing for the coordinated activation of complementary marketing such as emails or digital ads. For example, once you know a postcard promoting an upcoming sale has been delivered, you could then release a digital ad shortly after, reminding them of the promotion and helping keep your brand top of mind. </p>
              </div>
            </div>

            
            <div className='personalized-box secondary'>
              <h3>More than half of CPG companies use QR Codes in direct mail.</h3>
              <div data-aos data-aos-id="vector-shapes" className='shape-images'>
                <div className='triangle triangle-1'>
                  <img ref={triangle1Ref} src={cpgTriangle} alt="" />
                </div>
                <div className='square square-1'>
                  <img ref={square1Ref} src={cpgSquare} alt="" />
                </div>
                <div className='triangle triangle-2'>
                  <img ref={triangle2Ref} src={cpgTriangle} alt="" />
                </div>
                <div className='square square-2'>
                  <img ref={square2Ref} src={cpgSquare} alt="" />
                </div>
              </div>
            </div>
            
          </div>
        </div>

      </div>
    </>
  );
}
